import { LS_Snapshot, Annotation } from '../types/labelSchema';

export function validateAnnotations(onto: LS_Snapshot, anns: Annotation[]): { ok: boolean; errors: string[] } {
  const errors: string[] = [];
  const catSet = new Set(onto.categories.map(c => c.id));
  const byCat: Record<string, number> = {};
  
  for (const a of anns) {
    if (!a || !Array.isArray(a.bbox) || a.bbox.length !== 4) {
      errors.push('Invalid bbox');
    }
    if (!catSet.has(a.categoryId)) {
      errors.push(`Unknown category ${a.categoryId}`);
    }
    byCat[a.categoryId] = (byCat[a.categoryId] || 0) + 1;
  }
  
  for (const c of onto.categories) {
    const n = byCat[c.id] || 0;
    if (c.minInstances && n < c.minInstances) {
      errors.push(`Category ${c.id} requires ≥${c.minInstances}`);
    }
    if (c.maxInstances && n > c.maxInstances) {
      errors.push(`Category ${c.id} allows ≤${c.maxInstances}`);
    }
  }
  
  return {
    ok: errors.length === 0,
    errors
  };
}

